export const parsePathnameSegments = (pathname: string): string[] => {
  const normalizedPathname = pathname.split('?')[0].split('#')[0];
  return normalizedPathname.split('/').filter(Boolean);
};
